module.exports = __webpack_public_path__ + "img/stock2.bbe8a4ab.png";